"use strict";
/*
 *  Copyright (C) 2019  Attila Aldemir <a_aldemir@hotmail.de>
 *
 *  This program is free software: you can redistribute it and/or modify
 *  it under the terms of the GNU Affero General Public License as published
 *  by the Free Software Foundation, either version 3 of the License, or
 *  (at your option) any later version.
 *
 *  This program is distributed in the hope that it will be useful,
 *  but WITHOUT ANY WARRANTY; without even the implied warranty of
 *  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 *  GNU Affero General Public License for more details.
 *
 *  You should have received a copy of the GNU Affero General Public License
 *  along with this program.  If not, see <https://www.gnu.org/licenses/>.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var ardor_ts_1 = require("@blobaa/ardor-ts");
var __1 = require("../../..");
var DataFields_1 = __importDefault(require("../../lib/DataFields"));
var Helper_1 = __importDefault(require("../../lib/Helper"));
var ServiceHelper_1 = __importDefault(require("./utils/ServiceHelper"));
var RevocationService = /** @class */ (function () {
    function RevocationService(request) {
        this.request = request;
        this.helper = new ServiceHelper_1.default(request);
    }
    RevocationService.prototype.run = function (url, params, entityType, runChecks) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!runChecks) return [3 /*break*/, 1];
                        return [2 /*return*/, this.revoke(url, params, entityType, true)];
                    case 1: return [4 /*yield*/, this.revoke(url, params, __1.EntityType.LEAF, false)];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    RevocationService.prototype.revoke = function (url, params, entityType, runChecks) {
        return __awaiter(this, void 0, void 0, function () {
            var dataFields, attestedAccount;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        dataFields = new DataFields_1.default();
                        dataFields.attestationContext = params.attestationContext;
                        attestedAccount = "";
                        if (!runChecks) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.checkRevokeAttestation(url, params, entityType)];
                    case 1:
                        _a.sent();
                        attestedAccount = this.helper.getRecipient(params);
                        return [3 /*break*/, 3];
                    case 2:
                        attestedAccount = params.account;
                        _a.label = 3;
                    case 3: return [4 /*yield*/, this.revokeAttestation(url, params, attestedAccount)];
                    case 4: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    RevocationService.prototype.checkRevokeAttestation = function (url, params, entityType) {
        return __awaiter(this, void 0, void 0, function () {
            var attestedAccount, attestorAccount, dataFields, attestationContext, response, propertyObject, _error, error, setTypeName, foundTypeName, _error, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        attestedAccount = this.helper.getRecipient(params);
                        attestorAccount = ardor_ts_1.account.convertPassphraseToAccountRs(params.passphrase);
                        dataFields = new DataFields_1.default();
                        attestationContext = dataFields.setAttestationContext(params.attestationContext);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.request.getAccountProperties(url, {
                                setter: attestorAccount,
                                recipient: attestedAccount,
                                property: attestationContext
                            })];
                    case 2:
                        response = _a.sent();
                        propertyObject = response.properties[0];
                        if (!propertyObject) {
                            _error = Helper_1.default.createError(__1.ErrorCode.ATTESTATION_CONTEXT_NOT_FOUND, [attestedAccount]);
                            return [2 /*return*/, Promise.reject(_error)];
                        }
                        error = dataFields.consumeDataFieldString(propertyObject.value);
                        if (error.code !== __1.ErrorCode.NO_ERROR) {
                            return [2 /*return*/, Promise.reject(error)];
                        }
                        if (dataFields.entityType !== entityType) {
                            setTypeName = this.helper.getEntityTypeName(entityType);
                            foundTypeName = this.helper.getEntityTypeName(dataFields.entityType);
                            _error = Helper_1.default.createError(__1.ErrorCode.ENTITY_MISMATCH, [setTypeName, foundTypeName]);
                            return [2 /*return*/, Promise.reject(_error)];
                        }
                        return [3 /*break*/, 4];
                    case 3:
                        error_1 = _a.sent();
                        return [2 /*return*/, Promise.reject(Helper_1.default.getError(error_1))];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    RevocationService.prototype.revokeAttestation = function (url, params, recipient) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.helper.createRevokeTransaction(url, params, recipient, params.feeNQT)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, { transactionId: response.fullHash }];
                }
            });
        });
    };
    return RevocationService;
}());
exports.default = RevocationService;
